module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1794e752389f3226c85d95c381f8d3b4.1794e752.png";